import axios, { CanceledError } from "axios";
import envVars from "../env-configs";
import { fetchSourceIpFromProviders } from "./utils/fetchSourceIp";
import { isLogoutInProgress } from "./session/logoutState";

// --- IP Management Logic ---

let cachedIp: string | null = null;
let isFetching = false;
let hasAttemptedIpFetch = false;

const fetchIpAddress = async () => {
  // Only attempt once per session so a failed lookup does not delay later requests
  if (cachedIp || isFetching || hasAttemptedIpFetch) return;

  isFetching = true;
  hasAttemptedIpFetch = true;

  try {
    cachedIp = await fetchSourceIpFromProviders();
  } catch {
    cachedIp = null;
  } finally {
    isFetching = false;
  }
};

// --- Axios Setup ---

const axiosInstance = axios.create({
  baseURL: envVars.REACT_APP_SERVER_URL,
});

const selectedEndpoints = [
  "/v1/auth/new-flow/register",
  "/v1/orders/new-flow/create",
  "/v1/orders/new-flow",
  "v1/organizations/new-flow/create",
  "v1/sof/create-sof",
  "v1/sof/update-sof",
  "v1/users/invite",
  "v1/orders/new-flow/approval",
];

axiosInstance.interceptors.request.use(async (config: any) => {
  if (isLogoutInProgress()) {
    return Promise.reject(
      new CanceledError("Requests cancelled because logout is in progress")
    );
  }

  try {
    if (selectedEndpoints.some((link) => config.url.includes(link))) {
      if (
        config.url.includes("/v1/orders/new-flow/add-document") ||
        config.url.includes("/v1/orders/new-flow/multiple-download") ||
        config.url.includes("/v1/orders/new-flow/classify-supporting-documents") ||
        config.url.includes("/v1/orders/new-flow/check-duplicate")
      ) {
        return config;
      }

      if (!cachedIp) {
        await fetchIpAddress();
      }

      // Attach IP only when available — request proceeds either way
      if (cachedIp) {
        const isApproval = config.url === "v1/orders/new-flow/approval";
        config.data = {
          ...config.data,
          [isApproval ? "sourceIpAddress" : "SourceIpAddress"]: cachedIp,
        };
      }
    }
  } catch (error) {
    console.error("Interceptor error:", error);
  }
  return config;
});

export default axiosInstance;
